export default "__VITE_ASSET__DNzXOb8u__"